import React from "react";
import { styled } from "styled-components";
import { Color } from "../../theme/Color";
import { Section80, SubTitle } from "../DesignComponent/DesignComponents";
import { API_URL } from "../../redux/constants/constants";

const Logos = ({ title, unilever, whirlpool, mount, moura }) => {

  const Leaderslogo = styled.img`
    max-width: 160px;
    width: 100%;
  `;

  return (
      <Section80 className="trusted_sec text-center">
        <div className="container">
          <div className="row mb-lg-4 mb-2">
            <div className="col-12">
              <SubTitle
                className="sub-title mb-2"
                style={{ color: Color.darkBlack }}
              >
                {title || "Trusted by Innovative Leaders"}
              </SubTitle>
            </div>
          </div>
          <div className="row align-items-center justify-content-center">
            <div className="col-10">
              <div className="row align-items-center justify-content-center">
              <div className="col-md-3 col-6">
              <Leaderslogo
                src={
                  unilever ||
                  "https://staging2.theleansuite.com/wp-content/uploads/2023/09/unilever.webp"
                }
                alt={"unilever"}
                fetchpriority="low"
                loading="lazy"
              />
            </div>
            <div className="col-md-3 col-6">
              <Leaderslogo
                src={
                  whirlpool ||
                  "https://staging2.theleansuite.com/wp-content/uploads/2023/09/whirlpool.webp"
                }
                alt={"whirlpool"}
                fetchpriority="low"
                loading="lazy"
              />
            </div>
            <div className="col-md-3 col-6">
              <Leaderslogo
                src={
                  mount ||
                  "https://staging2.theleansuite.com/wp-content/uploads/2023/09/mount_franklin_foods.webp"
                }
                alt={"mount"}
                fetchpriority="low"
                loading="lazy"
              />
            </div>
            <div className="col-md-3 col-6">
              <Leaderslogo
                src={
                  moura ||
                  "https://staging2.theleansuite.com/wp-content/uploads/2023/09/moura.webp"
                }
                alt={"moura"}
                fetchpriority="low"
                loading="lazy"
              />
            </div>
              </div>
            </div>
          </div>
        </div>
      </Section80>
  );
};

export default Logos;
